import { ActivitySource } from '../registry/activity-source'
import type { ActivitySourceName } from '../types/activity-source'

const DOM_EVENTS = ['click', 'scroll', 'keydown', 'mousemove', 'touchstart', 'resize'] as const

const THROTTLE_MS = 2000

export class DomEventsActivitySource extends ActivitySource {
  readonly name: ActivitySourceName = 'dom-events'

  private lastNotifyTime = 0

  private handler = () => {
    const now = Date.now()
    if (now - this.lastNotifyTime < THROTTLE_MS) return
    this.lastNotifyTime = now
    this.notify()
  }

  protected setup(): void {
    for (const event of DOM_EVENTS) {
      window.addEventListener(event, this.handler, { passive: true })
    }
  }

  protected teardown(): void {
    for (const event of DOM_EVENTS) {
      window.removeEventListener(event, this.handler)
    }
  }
}
